import { useEffect, useState } from "react";
import { Flex } from "rebass/styled-components";
import styled from "styled-components";
import { MdHistory } from "react-icons/md";
import { BiSolidUserPlus } from "react-icons/bi";

import { analytics } from "MVVM/Analytics";
import {
  addAttributionParams,
  getAttributionUserId,
} from "MVVM/Utilities/Attribution";
import { useUser } from "MVVM/Hooks/useUser";

export const MatchHistoryButtons = ({
  gameId,
  matchId,
}: {
  gameId?: string;
  matchId?: string;
}) => {
  const { allstarUser } = useUser();
  const [linkCopied, setLinkCopied] = useState(false);

  const handleMatchHistoryClick = () => {
    if (gameId) {
      window.location.href = `/match-history?playerSearchIdentifier=${gameId}&skipLandingPage=true`;
    }
  };

  const copyMatchHistoryLink = () => {
    if (!gameId) return;

    const invitingUser = getAttributionUserId(allstarUser);
    analytics.track("Button - Click", {
      location: "profile-card",
      locationIdentifier: "inviteToAllstar",
      source: "website",
      invitingUser,
    });
    const baseUrl = `${window.location.origin}/match-history?matchId=${matchId}&playerSearchIdentifier=${gameId}&utm_source=clip-experience-invite-by-${invitingUser}`;
    const matchHistoryUrl = addAttributionParams(baseUrl, invitingUser);
    navigator.clipboard.writeText(matchHistoryUrl);
    setLinkCopied(true);
  };

  useEffect(() => {
    if (linkCopied) {
      setTimeout(() => {
        setLinkCopied(false);
      }, 2000);
    }
  }, [linkCopied]);

  return (
    <MatchHistoryButtonsContainer mt={7}>
      <MatchHistoryButton variant="primary" onClick={copyMatchHistoryLink}>
        <BiSolidUserPlus size={16} />
        {linkCopied ? "Link Copied!" : "Invite"}
      </MatchHistoryButton>
      <MatchHistoryButton variant="secondary" onClick={handleMatchHistoryClick}>
        <MdHistory size={16} />
        View Match History
      </MatchHistoryButton>
    </MatchHistoryButtonsContainer>
  );
};

const MatchHistoryButtonsContainer = styled(Flex)`
  gap: 8px;
`;

const MatchHistoryButton = styled.button<{ variant: "primary" | "secondary" }>`
  align-items: center;
  background: ${({ theme, variant }) =>
    variant === "primary" ? theme.colors.envy : theme.colors.navy50};
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  gap: 6px;
  height: 36px;
  justify-content: center;
  padding: 0 12px;
  min-width: 100px;
  flex: 0 0 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    background: ${({ theme, variant }) =>
      variant === "primary" ? theme.colors.envyAlpha50 : theme.colors.navy};
  }
`;
